export default __webpack_public_path__ + "static/media/02AW3SEP66.6f00b103.jpg";